import { MenuLink } from "../shared/interface/bcmenulink";

const menu: MenuLink[] = [
  {
    iconLink: "home",
    path: "/",
    label: "Inicio",
  },
  {
    iconLink: "main-users",
    path: "/usuarios",
    label: "Usuarios",
  },
  {
    iconLink: "book",
    path: "/formularios",
    label: "Formularios",
  },
  {
    iconLink: "documents",
    path: "/campos",
    label: "Campos",
  },
  {
    iconLink: "data",
    path: "/datos",
    label: "Datos",
  },
];

export { menu };
